import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "dropdown" ]

  connect() {
    const $dropdown = $(this.dropdownTarget).chosen();
    // Force Chosen to recalculate width after a short delay
    setTimeout(() => {
      $dropdown.trigger("chosen:updated");
      $dropdown.next('.chosen-container').css('width', '100%');
    }, 100);
  }
}
